import Vue from 'vue'
import VueRouter from 'vue-router'
import homeView from '../components/HomeView.vue'
import ImageToGif from '../components/ImageToGif.vue'
import ImageCompressor from '../components/ImageCompressor.vue'
import PdfToWord from '../components/PdfToWord.vue'
import PdfToImg from '../components/PdfToImg.vue'
import QrCodeGenerator from '../components/QrCodeGenerator.vue';
import JsonFormatter from '../components/JsonFormatter.vue';
import ImageWatermark from '../components/ImageWatermark.vue';
import VideoToGif from '../components/VideoToGif.vue';
import Ocr from '../components/Ocr.vue';
import PdfEditor from '../components/PdfEditor.vue';
import NetDiskShare from '../components/NetDiskShare.vue';
import ExcelToJSON from '../components/ExcelToJSON.vue';
import AudioExtractor from '../components/AudioExtractor.vue';
import InspectionReportForm from '../components/InspectionReportForm.vue';
import ProblemVerificationForm from '../components/ProblemVerificationForm222.vue';

Vue.use(VueRouter)
const routes = [{
        path: '/',
        name: 'home',
        component: homeView
    },
    {
        path: '/ImageToGif',
        name: 'ImageToGif',
        component: ImageToGif
    },
    {
        path: '/ImageCompressor',
        name: 'ImageCompressor',
        component: ImageCompressor
    },
    {
        path: '/PdfToWord',
        name: 'PdfToWord',
        component: PdfToWord
    },
    {
        path: '/PdfToImg',
        name: 'PdfToImg',
        component: PdfToImg
    }
    ,
    {
        path: '/QrCodeGenerator',
        name: 'QrCodeGenerator',
        component: QrCodeGenerator
    } ,
    {
        path: '/JsonFormatter',
        name: 'JsonFormatter',
        component: JsonFormatter
    },
    {
        path: '/ImageWatermark',
        name: 'ImageWatermark',
        component: ImageWatermark
    },
    {
        path: '/VideoToGif',
        name: 'VideoToGif',
        component: VideoToGif
    },
    {
        path: '/Ocr',
        name: 'Ocr',
        component: Ocr
    },
    {
        path: '/PdfEditor',
        name: 'PdfEditor',
        component: PdfEditor
    },
    {
        path: '/NetDiskShare',
        name: 'NetDiskShare',
        component: NetDiskShare
    },
    {
        path: '/ExcelToJSON',
        name: 'ExcelToJSON',
        component: ExcelToJSON
    },
    {
        path: '/AudioExtractor',
        name: 'AudioExtractor',
        component: AudioExtractor
    }
    ,
    {
        path: '/ProblemVerificationForm',
        name: 'ProblemVerificationForm',
        component: ProblemVerificationForm
    }
    ,
    {
        path: '/InspectionReportForm',
        name: 'InspectionReportForm',
        component: InspectionReportForm
    }
]
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
export default router